var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('v-row',{staticClass:"m-4"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","md":"12"}},[_c('h4',[_vm._v(" You can't load this page on this device right now because its performance isn't sufficient. "),_c('br'),_vm._v(" Please open this page on your PC. I apologize for any inconvenience... ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }